// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__21LsF","errorLogs":"styles_errorLogs__3hJqr"};